"use client";

import { Trans, useLingui } from "@lingui/react/macro";
import { AlertTriangleIcon } from "lucide-react";
import { useMemo } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { getErrorMessageDescriptor } from "./constants";

interface OverCapacityModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorType: string;
  locale?: "ja" | "en";
}

export function OverCapacityModal({
  isOpen,
  onClose,
  errorType,
}: OverCapacityModalProps) {
  const { i18n } = useLingui();

  const errorMessage = useMemo(
    () => i18n._(getErrorMessageDescriptor(errorType)),
    [errorType, i18n],
  );

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md" onClose={onClose}>
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangleIcon className="h-5 w-5 text-destructive" />
            <DialogTitle>
              <Trans>Plan limit reached</Trans>
            </DialogTitle>
          </div>
          <DialogDescription className="pt-3 text-sm text-foreground">
            {errorMessage}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button onClick={onClose} className="w-full">
            <Trans>Close</Trans>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
